// src/ui/components/modal-reload.js
//
// <modal-reload>
// ---------------
// A Soft Midnight Glass modal asking:
//   “Reload last directory?”
//
// Emits:
//   - confirm
//   - cancel
//
// Pure UI component. No logic or persistence here.

import {LitElement, html} from 'lit';
import {modalStyles} from 'ui/styles/modal.css.js';
import {glassStyles} from 'ui/styles/glass.css.js';

export class ModalReload extends LitElement {
  static styles = [glassStyles, modalStyles];

  static properties = {
    open: {type: Boolean},
    directoryName: {type: String}
  };

  constructor() {
    super();
    this.open = false;
    this.directoryName = '';
  }

  render() {
    return html`
      <div class="backdrop ${this.open ? 'open' : ''}">
        <div class="modal">
          <div class="title">Reload last directory?</div>

          <div class="message">
            ${this.directoryName
              ? html`<span class="accent">${this.directoryName}</span>`
              : 'Previous directory'}
          </div>

          <div class="buttons">
            <div class="btn" @click=${() => this._emit('cancel')}>
              Cancel
            </div>

            <div class="btn primary" @click=${() => this._emit('confirm')}>
              Reload
            </div>
          </div>
        </div>
      </div>
    `;
  }

  _emit(name) {
    this.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      composed: true
    }));
  }
}

customElements.define('modal-reload', ModalReload);